'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getSenderId, getSenderType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import SenderAvatar from '../avatar/SenderAvatar';
import ContentText from '../primary-message/ContentText';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import Sender from 'conversations-message-history/senders/records/Sender';
import TileMessageBody from '../tile-message/TileMessageBody';
import TileMessageContent from '../tile-message/TileMessageContent';
import TileMessageThumbnail from '../tile-message/TileMessageThumbnail';
import CommentMessageHeader from './CommentMessageHeader';
import FileAttachmentsFooter from '../attachments/FileAttachmentsFooter';
import { List } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommentContentOverrides = styled.div.withConfig({
  displayName: "CommentMessageBody__CommentContentOverrides",
  componentId: "sc-1r524v1-0"
})(["figure{img{width:100%;}}"]);
class CommentMessageBody extends PureComponent {
  render() {
    const {
      message,
      onClickAvatar,
      handleClickToDelete,
      senderName,
      senders,
      renderHeaderMetadata,
      onClickToDeleteComment,
      isHovered,
      fileAttachments
    } = this.props;
    const richTextContent = message.richText;
    const parsedContent = richTextContent && richTextContent.length ? richTextContent : message.text;
    const senderType = getSenderType(message);
    const senderId = getSenderId(message);
    const asyncSender = findSender(senderId, senderType, senders);
    const sender = getData(asyncSender) || Sender({
      senderType
    });
    const isLoading = isSenderLoading(asyncSender);
    const genericChannelId = getGenericChannelId(message);
    return /*#__PURE__*/_jsxs(TileMessageBody, {
      children: [/*#__PURE__*/_jsx(TileMessageThumbnail, {
        children: /*#__PURE__*/_jsx(SenderAvatar, {
          onClick: onClickAvatar,
          sender: sender,
          isLoading: isLoading
        })
      }), /*#__PURE__*/_jsxs(TileMessageContent, {
        children: [/*#__PURE__*/_jsx(CommentMessageHeader, {
          timestamp: message.timestamp,
          sender: sender,
          senderName: senderName,
          isLoading: isLoading,
          renderHeaderMetadata: renderHeaderMetadata,
          handleClickToDelete: handleClickToDelete,
          onClickToDeleteComment: onClickToDeleteComment,
          isHovered: isHovered
        }), /*#__PURE__*/_jsxs(CommentContentOverrides, {
          children: [/*#__PURE__*/_jsx(ContentText, {
            contentText: parsedContent
          }), fileAttachments && fileAttachments.size ? /*#__PURE__*/_jsx(FileAttachmentsFooter, {
            fileAttachments: fileAttachments,
            genericChannelId: genericChannelId
          }) : null]
        })]
      })]
    });
  }
}
CommentMessageBody.displayName = 'CommentMessageBody';
CommentMessageBody.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  handleClickToDelete: PropTypes.func,
  isHovered: PropTypes.bool,
  message: RecordPropType('CommentMessage').isRequired,
  onClickAvatar: PropTypes.func,
  onClickToDeleteComment: PropTypes.func,
  renderHeaderMetadata: PropTypes.func,
  senderName: PropTypes.node,
  senders: SenderMap
};
CommentMessageBody.defaultProps = {
  isHovered: false
};
export default CommentMessageBody;